import CopyToClipboard from "../copyToClipboard";
import React from "react";
import { highlightSlot } from "utils/searchResultHighlight";

const TempWorkerMission = ({ user, slotTerms, searchTerms }) => {
  const fullName = `${user.firstname || ''} ${user.lastname || ''}`.trim();
  const idBesttLabel = user.id_bestt ? `N°${user.id_bestt}` : '';
  const nameHighlightOptions = { fuzzy: true, searchTerms };

  return (
    <div className={'flex flex-col'}>
      <div className={'flex gap-1 items-center w-full flex-1 min-w-0'}>
        <div className={'text-base text-gray-900 truncate'}>
          <CopyToClipboard
            text={fullName}>
            <span className="truncate inline">
              {slotTerms || searchTerms?.length
                ? highlightSlot(fullName, slotTerms, 'tempWorkerName', nameHighlightOptions)
                : fullName}
            </span>
          </CopyToClipboard>
        </div>
        {user.id_bestt ? (
          <div>
            <CopyToClipboard
              text={user.id_bestt}>
              {slotTerms
                ? highlightSlot(idBesttLabel, slotTerms, 'tempWorkerName')
                : idBesttLabel}
            </CopyToClipboard>
          </div>
        ) : null}
      </div>
      {user.email ? (
        <div>
          <CopyToClipboard
            text={user.email}>
            <a href={`mailto:${user.email}`}>
              {slotTerms
                ? highlightSlot(user.email, slotTerms, 'tempWorkerEmail')
                : user.email}
            </a>
          </CopyToClipboard>
        </div>
      ) : null}
      {user.phone ? (
        <div>
          <CopyToClipboard
            text={user.phone}>
            <a href={`tel:${user.phone}`}>
              {slotTerms
                ? highlightSlot(user.phone, slotTerms, 'tempWorkerPhone')
                : user.phone}
            </a>
          </CopyToClipboard>
        </div>
      ) : null}
    </div>
  )
}

export default TempWorkerMission